import { CountryDeliveriesDistributionPart } from '@api/order-reporting/types-deliveries/CountryDeliveriesDistributionPart';



export type CountryDeliveriesSkuReportDetail = {
	country: string,
	executionPlace: string,
	executionPlaceName: string,
	transportTypesData: Record<SkuDetailTransportTypes, CountryDeliveriesDistributionPart>,
}



export enum SkuDetailTransportTypes {
	total = 'Total',
	on = 'ON',
	off = 'OFF',
}